import { ApolloError } from 'apollo-client';
import { AmberHoc, AmberHocProps, ContainerTypeLegacy } from '../../../util';
import {
  GrainContainerIdFragmentFragment as Result,
  withGetContainer as HOC,
} from '../__generated';

export type WithGetContainerHocOwnProps = {
  container_id: number;
  container_type: ContainerTypeLegacy;
  loading?: boolean;
  onError?: (error: ApolloError) => void;
};
export type WithGetContainerHocChildProps = {
  loading: boolean;
  grain_container: Result | null;
};
export const withGetContainerHoc: AmberHoc<
  WithGetContainerHocOwnProps,
  WithGetContainerHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<WithGetContainerHocOwnProps, WithGetContainerHocChildProps, typeof component>,
    WithGetContainerHocChildProps
  >({
    options: ({ container_id, container_type, onError }) => ({
      onError,
      errorPolicy: onError ? 'all' : 'none',
      variables: { container_id, container_type },
    }),
    props: ({ data, ownProps: { loading } }) => {
      if (!data || data.loading) {
        return {
          loading: true,
          grain_container: null,
        };
      }
      return {
        loading: loading || false,
        grain_container: data.grain_container || null,
      };
    },
  })(component as any);
